module.exports = __webpack_public_path__ + "img/car-yellow-left.1d8260ea.jpg";